import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#AEAEB2",
      d: "M8.962 13.043a.957.957 0 1 1-1.915 0V6.14H4.219a.72.72 0 1 1 0-1.438h7.562a.72.72 0 0 1 0 1.438H8.96zM12.5 2.719a.72.72 0 0 1-.72.72H4.22A.72.72 0 0 1 4.22 2h7.56a.72.72 0 0 1 .72.72"
    }, null, -1)
  ]))]))
}
export default { render: render }